(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anatomy-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const initialise = (scope = document) => {
      scope.querySelectorAll('.anatomy-home:not([data-anatomy-motion])').forEach((root) => {
        root.dataset.anatomyMotion = 'ready';

        if (motionQuery.matches) return;

        root.classList.add('anatomy-motion-ready');

        const groups = [
          ['.anatomy-manifest__intro > *', 'text'],
          ['.anatomy-benefit', 'card'],
          ['.anatomy-drop__media', 'media'],
          ['.anatomy-drop__copy > *', 'text'],
          ['.anatomy-process__header > *', 'text'],
          ['.anatomy-reel', 'media'],
          ['.anatomy-closing > p, .anatomy-closing > h2', 'text']
        ];

        const revealNodes = [];

        groups.forEach(([selector, type]) => {
          root.querySelectorAll(selector).forEach((node, index) => {
            node.dataset.anatomyReveal = node.matches('h1, h2, h3') ? 'headline' : type;
            node.style.setProperty('--anatomy-delay', `${Math.min(index, 3) * 90}ms`);
            revealNodes.push(node);
          });
        });

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting && entry.boundingClientRect.top >= window.innerHeight) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, {
          threshold: 0.12,
          rootMargin: '0px 0px -8% 0px'
        });

        revealNodes.forEach((node) => observer.observe(node));

        const revealInRange = () => {
          revealNodes.forEach((node) => {
            if (node.classList.contains('is-visible')) return;
            if (node.getBoundingClientRect().top > window.innerHeight * 0.92) return;
            node.classList.add('is-visible');
            observer.unobserve(node);
          });
        };

        const parallaxNodes = root.querySelectorAll('.anatomy-hero__media, .anatomy-drop__media');
        let frameRequested = false;

        const renderParallax = () => {
          revealInRange();
          parallaxNodes.forEach((node) => {
            const rect = node.getBoundingClientRect();
            const distance = (rect.top + rect.height / 2 - window.innerHeight / 2) / window.innerHeight;
            const offset = Math.max(-2.4, Math.min(2.4, distance * -2.4));
            node.style.setProperty('--anatomy-parallax', `${offset}rem`);
          });
          frameRequested = false;
        };

        const requestParallax = () => {
          if (frameRequested) return;
          frameRequested = true;
          window.requestAnimationFrame(renderParallax);
        };

        renderParallax();
        window.addEventListener('scroll', requestParallax, { passive: true });
        window.addEventListener('resize', requestParallax, { passive: true });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
    } else {
      initialise();
    }

    document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anatomy-radio"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeRadio = (section) => {
      if (!section || section.dataset.radioInitialized === 'true') return;

      const audio = section.querySelector('[data-radio-audio]');
      const tracks = Array.from(section.querySelectorAll('[data-radio-track]'));
      const status = section.querySelector('[data-radio-status]');
      const current = section.querySelector('[data-radio-current]');
      const power = section.querySelector('[data-radio-power]');
      const next = section.querySelector('[data-radio-next]');
      const menu = section.querySelector('[data-radio-menu]');
      const drawer = section.querySelector('[data-radio-drawer]');

      if (!audio || !status || !current || !power || !next || !menu || !drawer) return;

      section.dataset.radioInitialized = 'true';
      let currentIndex = Number(sessionStorage.getItem('anatomyRadioTrack') || 0);
      if (currentIndex < 0 || currentIndex >= tracks.length) currentIndex = 0;

      const assetReference = Array.from(document.querySelectorAll('link[href], script[src]')).find((element) => {
        const source = element.href || element.src;
        return source && source.includes('/assets/');
      });

      const themeAssetUrl = (filename) => {
        if (!filename || !assetReference) return '';
        const source = assetReference.href || assetReference.src;
        return new URL(filename, source.slice(0, source.lastIndexOf('/') + 1)).href;
      };

      const trackSource = (track) => {
        if (!track) return '';
        if (track.dataset.audioAsset && track.dataset.audioAsset.trim()) {
          return themeAssetUrl(track.dataset.audioAsset.trim());
        }
        return track.dataset.audioUrl ? track.dataset.audioUrl.trim() : '';
      };

      const isPlayable = (track) => Boolean(trackSource(track));

      const trackLabel = (track) => {
        if (!track) return section.dataset.emptyLabel;
        return [track.dataset.trackTitle, track.dataset.trackArtist].filter(Boolean).join(', ');
      };

      const setPlaying = (isPlaying) => {
        section.dataset.playing = String(isPlaying);
        status.textContent = isPlaying ? section.dataset.labelOn : section.dataset.labelOff;
        power.setAttribute('aria-label', isPlaying ? section.dataset.labelTurnOff : section.dataset.labelTurnOn);
      };

      const setMenu = (isOpen, returnFocus = false) => {
        section.dataset.menuOpen = String(isOpen);
        menu.setAttribute('aria-expanded', String(isOpen));
        menu.setAttribute('aria-label', isOpen ? section.dataset.labelCloseMenu : section.dataset.labelOpenMenu);
        drawer.setAttribute('aria-hidden', String(!isOpen));
        drawer.toggleAttribute('inert', !isOpen);
        if (!isOpen && returnFocus) menu.focus();
      };

      const updateSelection = (index) => {
        if (!tracks.length) {
          current.textContent = section.dataset.emptyLabel;
          return null;
        }

        currentIndex = (index + tracks.length) % tracks.length;
        tracks.forEach((track, trackIndex) => {
          if (trackIndex === currentIndex) track.setAttribute('aria-current', 'true');
          else track.removeAttribute('aria-current');
        });

        const track = tracks[currentIndex];
        current.textContent = isPlayable(track)
          ? trackLabel(track)
          : `${trackLabel(track)}. ${section.dataset.emptyLabel}`;
        sessionStorage.setItem('anatomyRadioTrack', String(currentIndex));
        return track;
      };

      const loadTrack = (index, shouldPlay = false) => {
        const track = updateSelection(index);
        if (!track) return;

        if (!isPlayable(track)) {
          audio.pause();
          audio.removeAttribute('src');
          audio.load();
          setPlaying(false);
          return;
        }

        const source = trackSource(track);
        if (audio.getAttribute('src') !== source) {
          audio.src = source;
          audio.load();
        }

        if (shouldPlay) audio.play().catch(() => setPlaying(false));
      };

      const playCurrent = () => {
        if (!tracks.length) {
          current.textContent = section.dataset.emptyLabel;
          setMenu(true);
          return;
        }

        if (!isPlayable(tracks[currentIndex])) {
          const firstPlayable = tracks.findIndex(isPlayable);
          if (firstPlayable === -1) {
            updateSelection(currentIndex);
            setMenu(true);
            return;
          }
          loadTrack(firstPlayable, true);
          return;
        }

        if (!audio.getAttribute('src')) loadTrack(currentIndex);
        audio.play().catch(() => setPlaying(false));
      };

      const nextTrackIndex = () => {
        if (!tracks.length) return -1;
        const playableTracks = tracks.filter(isPlayable);
        if (!playableTracks.length) return (currentIndex + 1) % tracks.length;

        for (let offset = 1; offset <= tracks.length; offset += 1) {
          const candidate = (currentIndex + offset) % tracks.length;
          if (isPlayable(tracks[candidate])) return candidate;
        }
        return currentIndex;
      };

      power.addEventListener('click', () => {
        if (audio.paused) playCurrent();
        else audio.pause();
      });

      next.addEventListener('click', () => {
        const nextIndex = nextTrackIndex();
        if (nextIndex === -1) {
          current.textContent = section.dataset.emptyLabel;
          setMenu(true);
          return;
        }
        const keepPlaying = !audio.paused;
        loadTrack(nextIndex, keepPlaying);
      });

      menu.addEventListener('click', () => setMenu(section.dataset.menuOpen !== 'true'));

      tracks.forEach((track, index) => {
        track.addEventListener('click', () => {
          loadTrack(index, true);
          setMenu(false);
        });
      });

      document.addEventListener('click', (event) => {
        if (section.dataset.menuOpen === 'true' && !section.contains(event.target)) setMenu(false);
      });

      section.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && section.dataset.menuOpen === 'true') setMenu(false, true);
      });

      audio.addEventListener('play', () => setPlaying(true));
      audio.addEventListener('pause', () => setPlaying(false));
      audio.addEventListener('ended', () => {
        const nextIndex = nextTrackIndex();
        if (nextIndex !== -1) loadTrack(nextIndex, true);
      });
      audio.addEventListener('error', () => setPlaying(false));

      setMenu(false);
      if (tracks.length) loadTrack(currentIndex);
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-anatomy-radio]').forEach((section) => initializeRadio(section));
    };

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    initializeAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
